export const workforceOperationalLayout = {
  controlHeight: 36,
  controlRadius: 6,
  detailDrawerWidth: 1040,
  headerHeight: 58,
  mobileControlHeight: 44,
  panelRadius: 8,
  queueWidth: 288,
  contextRailWidth: 320,
  rowMinHeight: 58,
  pagePaddingCompact: 14,
  pagePaddingWide: 20,
} as const;

export const workforceOperationalTypography = {
  body: {
    fontSize: 13,
    lineHeight: 19,
  },
  metadata: {
    fontSize: 11,
    lineHeight: 15,
  },
  pageTitle: {
    fontSize: 24,
    lineHeight: 30,
  },
  sectionTitle: {
    fontSize: 16,
    lineHeight: 22,
  },
  table: {
    fontSize: 12,
    lineHeight: 17,
  },
} as const;

export const workforceConfigurationDialog = {
  actionGap: 12,
  controlHeight: 40,
  fieldGap: 14,
  fieldLabelGap: 6,
  maxFormWidth: 760,
  paddingCompact: 16,
  paddingWide: 20,
  sectionGap: 18,
} as const;

export const workforceResponsiveBreakpoints = {
  compact: 700,
  medium: 900,
  wide: 1260,
} as const;
